import CustomElement from "./CustomElement";
import { debounce } from "../helpers";
import { gsap } from "gsap";


/**
 * Announcement Bar
 * @typedef {Object} CustomElement~AnnouncementBar
 */
export default class AnnouncementBar extends CustomElement {

	constructor() {

		super();

		this.header = this.closest("header");
		this.closeBtn = this.querySelector(".close");
		this.el = this.children[0];
		this.spacer = this.querySelector(".spacer");
		this.height = this.el.clientHeight;

		if(this.closeBtn) this.closeBtn.addEventListener("click", this.close.bind(this));
		if(this.spacer) this.spacer.style.height = this.height + "px";
	}

	close(event) {

		event.preventDefault();

		this.el.style.overflow = "hidden";

		gsap.to([this.el, this.spacer], {
			height: 0
		});
	}
}
